/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const paymentProviderEnumSchema = z
	.enum(["ALFA_BANK", "PAYGINE", "YOOKASSA", "TERMINAL", "CASH", "YANDEX_BADGE", "PAYMENT_TRACKER", "KASPI"])
	.describe(
		"* `ALFA_BANK` - ALFA_BANK\n* `PAYGINE` - PAYGINE\n* `YOOKASSA` - YOOKASSA\n* `TERMINAL` - TERMINAL\n* `CASH` - CASH\n* `YANDEX_BADGE` - YANDEX_BADGE\n* `PAYMENT_TRACKER` - PAYMENT_TRACKER\n* `KASPI` - KASPI",
	);
